<div id="lista" class="page-layout carded fullwidth inner-scroll">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

                <!-- HEADER -->
        <div class="header accent"
            fxLayout="column" fxLayoutAlign="center center"
            fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- TITLE AND BUTTONS -->
            <div fxLayout="row" fxLayoutAlign="start center" fxFlex="nogrow">
            <!-- APP TITLE -->
            <div class="logo"
                    fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    account_box
                </mat-icon>
                <span class="logo-text h1">
                    Clientes
                </span>
                
                <!-- HISTORY BUTTON -->
                <button mat-mini-fab 
                        color="accent"
                        matTooltip="Histórico de Relacionamento"
                        (click)="historicoRelacionamento()"
                        style="margin-left: 16px;">
                    <mat-icon>person_pin</mat-icon>
                </button>
            </div>
            </div>

            <!-- SEARCH -->
            <div class="search-wrapper mx-32 mx-md-0">
            <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">                    
                <input 
                    #filter 
                    placeholder="Buscar Por Nome, CPF ou Conta"
                    [formControl]="search"
                    (keyup)="onEnter(filter.value)"
                    (keyup.enter)="onEnter(filter.value)"
                >
                <mat-icon 
                    style="cursor: pointer;" 
                    (click)="getAll()"
                >
                    search
                </mat-icon>
            </div>
            </div>                    
            <!-- / SEARCH -->
        </div>

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table
                [loadingIndicator]="loadingIndicator"
                class='material' 
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50" 
                [rowHeight]="'auto'" 
                [rows]='rows'               
                [limit]="params.per_page"
                (sort)="onSort($event)"
            >

                <ngx-datatable-column name="Cliente" prop="nome" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span> {{row.nome}}</span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Assessor" prop="assessor" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span> {{row.assessor?.name}}</span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Escritório" prop="escritorio" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span> {{row.escritorio?.nome_fantasia}} </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Telefone" prop="telefone" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span> {{row.telefone ? row.telefone : 'Sem telefone'}} </span>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column 
                    name="Ações" 
                    prop="action" 
                    [sortable]="false" 
                    [width]="80"
                >
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <button 
                            mat-icon-button 
                            matTooltip="Cadastrar Histórico de Relacionamento" 
                            (click)="openCadastroHistorico(row)"
                        >
                            <mat-icon aria-label="Cadastrar Histórico de Relacionamento">person_pin</mat-icon>
                        </button>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>